import styled from "styled-components";

import COLOR from "../../../utils/colors.constants";

const Title2 = styled.h2`
  margin: 15px 0;
  border-top: 10px
  text-align: center;
  color: ${COLOR.AZUL};
`;

export default Title2;
